import { createStore } from "vuex";
import * as getters from "./getters";
import * as actions from "./actions";
import mutations from "./mutations";

const state = {
  currentEditor: "background",
  currentInlayIndex: 0,
  parsedInlays: {},
  currentProject: [],
  selectedLEDs: [],
  selectedBtns: [],
  selectedTexts: [],
  selectedGT6LInlay: 0,
  currentInlay: {},
  currentProjectName: "",
  selectedBarG: [],
  selectedBarGLEDs: [],
  inlaySave: [],
  draggingText: false,
  imgs: {
    light: [
      "light/Licht_1.svg",
      "light/Licht_2.svg",
      "light/Licht_3.svg",
      "light/Licht_4.svg",
      "light/Licht_5.svg",
      "light/Licht_6.svg",
      "light/Licht_7.svg",
      "light/Licht_8.svg",
      "light/Licht_9.svg",
      "light/Licht_10.svg",
      "light/Licht_11.svg",
      "light/Licht_12.svg",
      "light/Licht_13.svg",
      "light/Licht_14.svg",
      "light/Licht_15.svg",
      "light/Licht_16.svg",
      "light/Licht_17.svg",
      "light/Licht_18.svg",
      "light/Licht_19.svg",
      "light/Licht_20.svg",
      "light/Licht_21.svg",
      "light/Licht_22.svg",
      "light/Licht_23.svg",
      "light/Licht_24.svg",
      "light/Licht_25.svg",
      "light/Licht_26.svg",
      "light/Licht_27.svg",
    ],
    security: [
      "security/Zutritt_1.svg",
      "security/Zutritt_2.svg",
      "security/Zutritt_3.svg",
      "security/Zutritt_4.svg",
      "security/Zutritt_5.svg",
      "security/Zutritt_6.svg",
      "security/Zutritt_7.svg",
      "security/Zutritt_8.svg",
      "security/Zutritt_9.svg",
      "security/Zutritt_10.svg",
      "security/Zutritt_11.svg",
      "security/Zutritt_12.svg",
      "security/Zutritt_13.svg",
      "security/Zutritt_14.svg",
      "security/Zutritt_15.svg",
      "security/Zutritt_16.svg",
    ],
    central: [
      "central/Zentral_1.svg",
      "central/Zentral_2.svg",
      "central/Zentral_3.svg",
      "central/Zentral_4.svg",
      "central/Zentral_5.svg",
      "central/Zentral_6.svg",
      "central/Zentral_7.svg",
      "central/Zentral_8.svg",
      "central/Zentral_9.svg",
      "central/Zentral_10.svg",
      "central/Zentral_11.svg",
      "central/Zentral_12.svg",
      "central/Zentral_13.svg",
      "central/Zentral_14.svg",
      "central/Zentral_15.svg",
      "central/Zentral_16.svg",
    ],
    climate: [
      "climate/Klima_1.svg",
      "climate/Klima_2.svg",
      "climate/Klima_3.svg",
      "climate/Klima_4.svg",
      "climate/Klima_5.svg",
      "climate/Klima_6.svg",
      "climate/Klima_7.svg",
      "climate/Klima_8.svg",
      "climate/Klima_9.svg",
      "climate/Klima_10.svg",
      "climate/Klima_11.svg",
      "climate/Klima_12.svg",
      "climate/Klima_13.svg",
      "climate/Klima_14.svg",
      "climate/Klima_15.svg",
      "climate/Klima_16.svg",
      "climate/Klima_17.svg",
      "climate/Klima_18.svg",
    ],
    windows: [
      "windows/Fenster_1.svg",
      "windows/Fenster_2.svg",
      "windows/Fenster_3.svg",
      "windows/Fenster_4.svg",
      "windows/Fenster_5.svg",
      "windows/Fenster_6.svg",
      "windows/Fenster_7.svg",
      "windows/Fenster_8.svg",
      "windows/Fenster_9.svg",
      "windows/Fenster_10.svg",
      "windows/Fenster_11.svg",
      "windows/Fenster_12.svg",
      "windows/Fenster_13.svg",
      "windows/Fenster_14.svg",
      "windows/Fenster_15.svg",
      "windows/Fenster_16.svg",
      "windows/Fenster_17.svg",
      "windows/Fenster_18.svg",
      "windows/Fenster_19.svg",
      "windows/Fenster_20.svg",
      "windows/Fenster_21.svg",
      "windows/Fenster_22.svg",
      "windows/Fenster_23.svg",
      "windows/Fenster_24.svg",
      "windows/Fenster_25.svg",
      "windows/Fenster_26.svg",
      "windows/Fenster_27.svg",
      "windows/Fenster_28.svg",
      "windows/Fenster_29.svg",
    ],
    media: [
      "media/Media_1.svg",
      "media/Media_2.svg",
      "media/Media_3.svg",
      "media/Media_4.svg",
      "media/Media_5.svg",
      "media/Media_6.svg",
      "media/Media_7.svg",
      "media/Media_8.svg",
      "media/Media_9.svg",
      "media/Media_10.svg",
      "media/Media_11.svg",
      "media/Media_12.svg",
      "media/Media_13.svg",
      "media/Media_14.svg",
      "media/Media_15.svg",
      "media/Media_16.svg",
      "media/Media_17.svg",
      "media/Media_18.svg",
      "media/Media_19.svg",
      "media/Media_20.svg",
      "media/Media_21.svg",
      "media/Media_22.svg",
      "media/Media_23.svg",
      "media/Media_24.svg",
      "media/Media_25.svg",
    ],
    others: [
      "others/Sonstige_1.svg",
      "others/Sonstige_2.svg",
      "others/Sonstige_3.svg",
      "others/Sonstige_4.svg",
      "others/Sonstige_6.svg",
      "others/Sonstige_7.svg",
      "others/Sonstige_8.svg",
      "others/Sonstige_9.svg",
      "others/Sonstige_10.svg",
      "others/Sonstige_11.svg",
    ],
    connection: [
      "connection/Connect_1.svg",
      "connection/Connect_2.svg",
      "connection/Connect_3.svg",
      "connection/Connect_4.svg",
      "connection/Connect_5.svg",
    ],
    hotel: [
      "hotel/Hotel_1.svg",
      "hotel/Hotel_2.svg",
      "hotel/Hotel_3.svg",
      "hotel/Hotel_4.svg",
      "hotel/Hotel_5.svg",
      "hotel/Hotel_6.svg",
      "hotel/Hotel_7.svg",
      "hotel/Hotel_8.svg",
      "hotel/Hotel_9.svg",
      "hotel/Hotel_10.svg",
      "hotel/Hotel_11.svg",
    ],
  },
  lastColor: "",
  moveTexts: true,
  smallKeys: false,
};

export default createStore({
  state,
  getters,
  actions,
  mutations,
});
